import type { ComponentPropsWithRef } from "react";

import { cn } from "@/lib/utils";

export const Input = ({
  className,
  type,
  ...props
}: ComponentPropsWithRef<"input">) => (
  <input
    className={cn(
      "peer flex h-10 w-full min-w-0 rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-xs outline-none ring-ring/10 transition-[color,box-shadow] selection:bg-primary selection:text-primary-foreground file:inline-flex file:border-0 file:bg-transparent file:font-medium file:text-foreground file:text-sm placeholder:text-muted-foreground focus-visible:ring-4 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive/60 aria-invalid:ring-destructive/20 aria-invalid:focus-visible:ring-[3px] md:text-sm dark:bg-input/30 dark:ring-ring/60 dark:aria-invalid:border-destructive dark:aria-invalid:ring-destructive/40 dark:aria-invalid:focus-visible:ring-4",
      className
    )}
    data-slot="input"
    type={type}
    {...props}
  />
);
